export const frontmatter = {
    "draft": false,
    "title": "Chatbots",
    "sidebar_group": "referencia",
    "sidebar_label": "Chatbots",
    "sidebar_order": 2
}

export const toc = []